export default {
	methods: 
    {		
		async getFiltrar()
		{
			await this.getDataGet({ route: 'get_autorizar', data: 'autorizar'})
			// frontend await this.searchGetIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
		}		
	},
}